// extracted by mini-css-extract-plugin
export default {"title":"Title_title__CPmMl","underLineShort":"Title_underLineShort__Kk9dh","underLineLong":"Title_underLineLong__FMaJ-"};